import React from "react";

const NoDataAvailable = ({ title }) => {
  return (
    <>
      <div style={{ height: "380px", paddingTop: "20px", fontSize: "1.2rem" }}>
        No Data available {title && `for ${title}`}
      </div>
    </>
  );
};

export default NoDataAvailable;
